import { DistributorListType, FundManager, Trustee } from './api-types';

export const GET_FUNDS_LIST = 'GET_FUNDS_LIST';
export const GET_FUNDS_LIST_SUCCESS = 'GET_FUNDS_LIST_SUCCESS';

export const ADD_FUND = 'ADD_FUND';
export const ADD_FUND_SUCCESS = 'ADD_FUND_SUCCESS';

export const ADD_PLAN = 'ADD_PLAN';
export const ADD_PLAN_SUCCESS = 'ADD_PLAN_SUCCESS';

export const UPDATE_PLAN = 'UPDATE_PLAN';
export const UPDATE_PLAN_SUCCESS = 'UPDATE_PLAN_SUCCESS';

export const GET_FUNDS_ACCESS = 'GET_FUNDS_ACCESS';
export const GET_FUNDS_ACCESS_SUCCESS = 'GET_FUNDS_ACCESS_SUCCESS';

export const UPDATE_FUND = 'UPDATE_FUND';
export const UPDATE_FUND_SUCCESS = 'UPDATE_FUND_SUCCESS';

export const GET_PLAN = 'GET_PLAN';
export const GET_PLAN_SUCCESS = 'GET_PLAN_SUCCESS';

export const GET_PLAN_DETAILS = 'GET_PLAN_DETAILS';
export const GET_PLAN_DETAILS_SUCCESS = 'GET_PLAN_DETAILS_SUCCESS';

export type GetFundsListResponseBody = {
  funds: FundProps[];
};

export type FundProps = {
  amcId: number;
  schemeCode: string;
  schemeName: string;
  amcCode: string;
  bankName: string;
  bankBranch: string;
  ifscCode: string;
  bankAccountNumber: string;
  paymentApiKey?: string | null;
  isActive: boolean;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  plans: ClassPlanProps[];
  id: string;
  isInvestorWithPanApplicable: boolean;
  leegalityStampSeries?: string | null;
  leegalityStampSeriesGroup?: string | null;
  leegalityStampValue?: number | null;
  leegalityUseStampSeries?: boolean | null;
  stampSeriesType?: 'single' | 'multi' | null;
  multipleStampSeries?: MultiStampSeriesEntry[] | null;
  isOnlyXalt?: boolean | null;
  [key: string]:
    | string
    | number
    | boolean
    | ClassPlanProps[]
    | MultiStampSeriesEntry[]
    | undefined
    | null;
  journeyType: string | null;
  isXorbit?: boolean | null;
};

export type accessType = {
  fundSetupAccess: boolean;
};

export type MultiStampSeriesEntry = {
  stampSeries: string;
  seriesQuantity: string;
};

export type addFundType = {
  bankAccountNumber: string;
  schemeCode: string;
  schemeName: string;
  amcCode: string;
  bankName: string;
  bankBranch: string;
  ifscCode: string;
  paymentApiKey: string;
  isInvestorWithPanApplicable: boolean;
  leegalityStampSeries: string | null;
  leegalityStampSeriesGroup: string | null;
  leegalityStampValue: number | null;
  leegalityUseStampSeries: boolean | null;
  stampSeriesType?: 'single' | 'multi' | null;
  multipleStampSeries?: MultiStampSeriesEntry[] | null;
  isOnlyXalt?: boolean | null;
  journeyType: string | null;
  isXorbit?: boolean | null;
};

export type addPlanType = {
  schemeId: number | string | null;
  planCode: string;
  planDescription: string;
  schemeNature: string;
  registrationNumber: string;
  schemeCategory: string;
  country: string;
  currency: string;
  transactionCurrency: string;
  schemeStartDate: string;
  lockInPeriod: string;
  lockInExtension: string;
  inActive: boolean;
  faceValue: number | null;
  fundAddress1: string;
  fundAddress2: string;
  fundAddress3: string;
  isActive: boolean;
  custodian: string;
  setupFee: number | null;
  fundManagerId: number | null;
  trusteeId: number | null;
  minCommitmentAmount: number | null;
  maxCommitmentAmount: number | null;
  minContributionPercentage: number | null;
  managementFee: number | null;
  tcLink: string;
  performanceFee: string | null;
  totalExpense: number | null;
  placementFee: number | null;
  isPlacementFeeApplicable: string;
  hurdleRateOfReturns: string | null;
  distributorIds: string[] | number[] | null;
  isApplicableForDirect: boolean;
  operatingExpenseApplicable: string | null;
  operatingExpenseInWords: string | null;
  exitLoadApplicable: string | null;
  exitLoadInWords: string | null;
  placementFeeType: string | null;
  minPlacementFee: number | null;
  maxPlacementFee: number | null;
  investmentPlanType: string | null;
  investmentPlanApplicable: string | null;
};

export type addFundPlanType = {
  schemeCode: string;
  schemeName: string;
  amcCode: string;
  bankName: string;
  bankBranch: string;
  ifscCode: string;
  bankAccountNumber: string;
  paymentApiKey: string;
  id: string;
  schemeId: number | null;
  planCode: string;
  planDescription: string;
  schemeNature: string;
  registrationNumber: string;
  schemeCategory: string;
  country: string;
  currency: string;
  transactionCurrency: string;
  schemeStartDate: string;
  lockInPeriod: string;
  lockInExtension: string;
  inActive: boolean;
  faceValue: number | null;
  fundAddress1: string;
  fundAddress2: string;
  fundAddress3: string;
  isActive: boolean;
  custodian: string;
  setupFee: number | null;
  fundManagerId: number | null;
  trusteeId: number | null;
  minCommitmentAmount: number | null;
  maxCommitmentAmount: number | null;
  minContributionPercentage: number | null;
  managementFee: number | null;
  totalExpense: number | null;
  placementFee: number | null;
  isPlacementFeeApplicable: string;
  tcLink: string;
  performanceFee: string | null;
  hurdleRateOfReturns: string | null;
  leegalityStampSeries: string | null;
  leegalityStampSeriesGroup: string | null;
  leegalityStampValue: number | null;
  leegalityUseStampSeries: boolean | null;
  stampSeriesType?: 'single' | 'multi' | null;
  multipleStampSeries?: MultiStampSeriesEntry[] | null;
  distributorIds: string[] | number[] | null;
  isApplicableForDirect: boolean;
  isInvestorWithPanApplicable: boolean | null;
  operatingExpenseApplicable: string | null;
  operatingExpenseInWords: string | null;
  exitLoadApplicable: string | null;
  exitLoadInWords: string | null;
  placementFeeType: string | null;
  minPlacementFee: number | null;
  maxPlacementFee: number | null;
  investmentPlanType: string | null;
  investmentPlanApplicable: string | null;
  isOnlyXalt?: boolean | null;
  journeyType: string | null;
  isXorbit?: boolean | null;
};

export type DistributorDetailsInPlans = {
  distributorIds: string[] | number[];
  distributors: DistributorListType[];
};
export type ClassPlanProps = {
  id: string;
  schemeId: any;
  planCode: string;
  fundManagerId: number | null;
  trusteeId: number | null;
  planDescription: string;
  schemeNature: string;
  registrationNumber: string;
  schemeCategory: string;
  country: string;
  fundManager: FundManager;
  trustee: Trustee;
  currency: string;
  transactionCurrency: string;
  schemeStartDate: string;
  lockInPeriod: string;
  lockInExtension: string;
  inActive: boolean;
  faceValue: number | null;
  fundAddress1: string;
  fundAddress2: string;
  fundAddress3: string;
  custodian: string;
  setupFee: number | null;
  minCommitmentAmount: number;
  maxCommitmentAmount: number;
  minContributionPercentage: number;
  managementFee: number;
  isActive: boolean;
  tcLink: string;
  createdBy: number | null;
  createdAt: string;
  updatedAt: string;
  performanceFee: string | null;
  totalExpense: number | null;
  placementFee: number | null;
  isPlacementFeeApplicable: string;
  hurdleRateOfReturns: string | null;
  distributorDetails: DistributorDetailsInPlans;
  distributorIds: string[] | number[] | null;
  isApplicableForDirect: boolean;
  operatingExpenseApplicable: string | null;
  operatingExpenseInWords: string | null;
  exitLoadApplicable: string | null;
  exitLoadInWords: string | null;
  placementFeeType: string | null;
  minPlacementFee: number | null;
  maxPlacementFee: number | null;
  investmentPlanType: string | null;
  investmentPlanApplicable: string | null;
};

export const GET_FUNDS_SUCCESS = 'GET_FUNDS_SUCCESS';
export const GET_FUNDS = 'GET_FUNDS';

export const GET_DIRECTAPPLICABLEFUNDS_SUCCESS = 'GET_DIRECTAPPLICABLEFUNDS_SUCCESS';
export const GET_DIRECTAPPLICABLEFUNDS = 'GET_DIRECTAPPLICABLEFUNDS';
export const EXPORT_FUNDS_SUCCESS = 'EXPORT_FUNDS_SUCCESS';
export const EXPORT_FUNDS = 'EXPORT_FUNDS';
